import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Radio,
  FormGroup,
  Grid,
  Checkbox,
  Label,
  Dropdown,
  Message,
} from "semantic-ui-react";
import api from "../config/axios";
import { savequestionsheet, saveImagequestion } from "./api/questionsheet";
import { 
  Box, 
  Icon, 
  useToast,
  VStack,
  HStack,
  Text,
  Input as ChakraInput,
  InputGroup,
  InputRightElement,
  IconButton,
  Tooltip,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Badge,
  Divider,
  Button as ChakraButton
} from "@chakra-ui/react";
import { EmailIcon, ViewIcon } from "@chakra-ui/icons";
import {
  createOrUpdateTest,
  getTestByAssesment,
  getTestCreation,
  getTestId,
  uploadcompanyLogo,
  DownloadCertificate,
} from "./api/recruiter";
import Router, { useRouter } from "next/router";
import axios from "axios";
import url from "../config/config.json";
import CsvUploader from "./csvUploader.js";
import HelpIconWithTooltip from "../components/HelpIconWithTooltip.js";
import PublicLinkModal from "../components/PublicLinkModal.js";

import { ConsoleLogAction } from "./api/recruiter.js";

function TestSettingsModal({
  isTestSettingsModalOpen,
  setIsTestSettingModalOpen,
  userId,
  companyId,
  testId,
  fetchResponse,
  customerId,
  assessmentType,
}) {
  //new changes
  const [testData, setTestData] = useState(null);
  const router = useRouter();
  const [questionSheetType, setQuestionSheetType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [testDifficulty, setTestDifficult] = useState("default");
  const [testProficiency, setTestProficiency] = useState("beginner");
  const [testType, setType] = useState("test");
  const [nameTest, setNameTest] = useState("");
  const [imageFolderName, setImageFolderName] = useState("");
  const [isCalculatorEnabled, setIsCalculatorEnabled] = useState("no");

  const [time, setTime] = useState("");
  const [skill, setSkill] = useState("");
  const [skills, setSkills] = useState("");
  const [skillOptionArray, setSkillOptionArray] = useState([]);

  const [tokenExpiration, setTokenExpiration] = useState();
  const [totalMcqQuestion, setTotalMcqQuestion] = useState("");
  const [totalMriQuestion, setTotalMriQuestion] = useState("");
  const [totalFillBlanksQuestion, setTotalFillBlanksQuestion] = useState("");
  const [totalDescriptiveQuestion, setTotalDescriptiveQuestion] = useState("");
  const [totalCodingQuestion, setTotalCodingQuestion] = useState("");
  const [easyMcqCount, setEasyMcqCount] = useState(0);
  const [mediumMcqCount, setMediumMcqCount] = useState(0);
  const [hardMcqCount, setHardMcqCount] = useState(0);

  const [easyMriCount, setEasyMriCount] = useState(0);
  const [mediumMriCount, setMediumMriCount] = useState(0);
  const [hardMriCount, setHardMriCount] = useState(0);

  const [easyFillBlanksCount, setEasyFillBlanksCount] = useState(0);
  const [mediumFillBlanksCount, setMediumFillBlanksCount] = useState(0);
  const [hardFillBlanksCount, setHardFillBlanksCount] = useState(0);

  const [easyDescriptiveCount, setEasyDescriptiveCount] = useState(0);
  const [mediumDescriptiveCount, setMediumDescriptiveCount] = useState(0);
  const [hardDescriptiveCount, setHardDescriptiveCount] = useState(0);

  const [easyCodingCount, setEasyCodingCount] = useState(0);
  const [mediumCodingCount, setMediumCodingCount] = useState(0);
  const [hardCodingCount, setHardCodingCount] = useState(0);
  const [filetype, setFileType] = useState("csv");

  const [csvFile, setCsvFile] = useState(null);
  const [zipFile, setZipFile] = useState(null);
  const [nameTestError, setNameTestError] = useState(false);
  const [timeError, setTimeError] = useState(false);
  const [tokenExpirationError, setTokenExpirationError] = useState(false);
  const [isSettingsSaved, setIsSettingsSaved] = useState(false);
  const toast = useToast();

  const [csvFiles, setCsvFiles] = useState([]);
  const [selectedCsvFile, setSelectedCsvFile] = useState("");
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [fileError, setFileError] = useState(null);
  const [csvFilesList, setCsvFilesList] = useState([]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);

  const [baseUploadResponse, setBaseUploadResponse] = useState(null);
  const [isAutoPopulated, setIsAutoPopulated] = useState(false);
  const [isCampusEnabled, setIsCampusEnabled] = useState(false);
  const [isPublicUrlEnabled, setIsPublicUrlEnabled] = useState(false);
  const [isNegativeMarkingEnabled, setIsNegativeMarkingEnabled] = useState(false);
  const [negativeMarkValue, setNegativeMarkValue] = useState("");
  
  // Public link states
  const [copied, setCopied] = useState(false);
  const [publicUrl, setPublicUrl] = useState("");
  const [isPublicLinkModalOpen, setIsPublicLinkModalOpen] = useState(false);
  const [showPublicLinkSection, setShowPublicLinkSection] = useState(false);
  
  const [logresponse, setLogResponse] = useState(null);

  const [errorResponse, setErrorResponse] = useState(null);

  const [useriddata, setUserIdData] = useState(null);

  const [usertypedata, setUserTypeData] = useState(null);

  const [apiResponses, setApiResponses] = useState({
    setPassing: null,
    generateCertificate: null,
  });

  // Generate public URL
  useEffect(() => {
    if (testId && typeof window !== 'undefined') {
      setPublicUrl(`${window.location.origin}/public-assessment/${testId}`);
    }
  }, [testId]);

  // Reset state when modal opens or testId changes
  useEffect(() => {
    if (isTestSettingsModalOpen) {
      // If testId exists, fetch the test settings
      if (testId) {
        fetchTestSettings();
        fetchCalculatorSettings();
      } else {
        // If no testId (creating new test), reset all fields
        resetTestFields();
      }
    }
  }, [isTestSettingsModalOpen, testId]);

  // Handle copy link
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
      setCopied(true);
      toast({
        title: "Link copied to clipboard!",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      
      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
      toast({
        title: "Failed to copy link",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  // Handle open link
  const handleOpenLink = () => {
    window.open(publicUrl, "_blank");
  };

  const handleFileSet = (e) => {
    e.preventDefault();
    setSelectedFile(e.target.files[0]);
  };

  const handleCsvFileUpload = (event) => {
    setCsvFile(event.target.files[0]);
  };

  useEffect(() => {
    // If it's an interview assessment, force to "test" type and prevent training
    if (assessmentType === "interview") {
      setType("test");
    }
    // For certificate assessment, allow both but default to current value
    else if (assessmentType === "certificate") {
      // Keep current testType or default to 'test' if not set
      if (!testType) {
        setType("test");
      }
    }
  }, [assessmentType]); // Remove testType from dependencies to avoid infinite loop

  // Add these console logs to your TestSettingsModal.js file

  // In the handleZipFileUpload function
  const handleZipFileUpload = (event) => {
    const file = event.target.files[0];
    setZipFile(file);

    // Extract the folder name from the zip file name (without extension)
    if (file) {
      const fileName = file.name;
      const folderName = fileName.substring(0, fileName.lastIndexOf("."));
      setImageFolderName(folderName);
      console.log("Set image folder name to:", folderName);
    }
  };

  const handleTemplateDownload = () => {
    window.location.href = "../assesment template.csv";
  };

  const fetchCsvFiles = async () => {
    setIsLoadingFiles(true);
    try {
      const formData = new FormData();
      formData.append("company_id", companyId);

      const response = await api.post("/list_csv_files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("API Response:", response.data); // Debug log

      // Check if response.data.files exists and is an array
      if (Array.isArray(response.data.files)) {
        const fileOptions = response.data.files.map((file, index) => {
          const displayName = file
            .replace(/__/g, " ")
            .replace(/\s*\(\d+\)$/, "")
            .replace(/_/g, " ")
            .trim();

          return {
            key: String(index), // Convert to string to ensure compatibility
            text: displayName,
            value: file,
          };
        });

        console.log("Processed Options:", fileOptions); // Debug log
        setCsvFilesList(fileOptions);
      } else {
        console.error("No files array in response:", response.data);
        setCsvFilesList([]); // Set empty array if no files
      }
    } catch (error) {
      console.error("Error fetching CSV files:", error);
      setCsvFilesList([]); // Set empty array on error
    } finally {
      setIsLoadingFiles(false);
    }
  };

  useEffect(() => {
    fetchCsvFiles();
  }, []);

  useEffect(() => {
    if (companyId) {
      fetchCsvFiles(); // Call the function only if companyId is available
    }
  }, [companyId]);

  // Handle file selection
  const handleCsvFileSelection = async (fileName) => {
    setSelectedCsvFile(fileName); // Update selected file
    try {
      const response = await api.post("/fetch_test_details", {
        file_name: fileName,
        company_id: companyId,
      });
      console.log("API Response:", response.data);

      // Auto-populate the fields with the response data
      setNameTest(response.data.test_name || "");
      setTotalMcqQuestion(response.data.total_mcq_count || 0);
      setTotalMriQuestion(response.data.total_mri_count || 0);
      setTotalFillBlanksQuestion(response.data.total_fill_blanks_count || 0);
      setTotalDescriptiveQuestion(response.data.total_descriptive_count || 0);
      setTotalCodingQuestion(response.data.total_coding_count || 0);
      setTime(
        response.data.total_time ? response.data.total_time.toString() : ""
      );
      setSkill(fileName); // Assuming you want to set the file name as skill

      // Set difficulty level counts with null checks
      setEasyMcqCount(response.data.easy_mcq_count || 0);
      setMediumMcqCount(response.data.medium_mcq_count || 0);
      setHardMcqCount(response.data.hard_mcq_count || 0);

      setEasyMriCount(response.data.easy_mri_count || 0);
      setMediumMriCount(response.data.medium_mri_count || 0);
      setHardMriCount(response.data.hard_mri_count || 0);

      setEasyFillBlanksCount(response.data.easy_fill_blanks_count || 0);
      setMediumFillBlanksCount(response.data.medium_fill_blanks_count || 0);
      setHardFillBlanksCount(response.data.hard_fill_blanks_count || 0);

      setEasyDescriptiveCount(response.data.easy_descriptive_count || 0);
      setMediumDescriptiveCount(response.data.medium_descriptive_count || 0);
      setHardDescriptiveCount(response.data.hard_descriptive_count || 0);

      setEasyCodingCount(response.data.easy_coding_count || 0);
      setMediumCodingCount(response.data.medium_coding_count || 0);
      setHardCodingCount(response.data.hard_coding_count || 0);

      setIsAutoPopulated(true); // If you want to track whether the fields are populated

      toast({
        title: "CSV file processed successfully!",
        status: "success",
        position: "top",
        isClosable: true,
        duration: 2000,
      });
    } catch (error) {
      console.error("Error fetching test details:", error);
      setFileError("Failed to fetch test details. Please try again.");
      toast({
        title: "Error fetching file details",
        description: error.message,
        status: "error",
        position: "top",
        isClosable: true,
        duration: 2000,
      });
    }
  };

  const calculateTotalTime = (counts) => {
    const {
      mcq = parseInt(totalMcqQuestion) || 0,
      mri = parseInt(totalMriQuestion) || 0,
      fillBlanks = parseInt(totalFillBlanksQuestion) || 0,
      descriptive = parseInt(totalDescriptiveQuestion) || 0,
      coding = parseInt(totalCodingQuestion) || 0,
    } = counts;

    return (
      (mcq + mri + fillBlanks) * 1 + // 1 minute each for MCQ, MRI, and Fill Blanks
      descriptive * 3 + // 3 minutes each for Descriptive
      coding * 5 // 5 minutes each for Coding
    );
  };

  const handleQestionUpload = async () => {
    if (csvFile) {
      const fileName = csvFile.name;
      const sheetName = fileName.substring(0, fileName.lastIndexOf("."));

      try {
        const response = await savequestionsheet(csvFile, sheetName, companyId);
        setBaseUploadResponse(response);

        // Auto-populate the fields
        setNameTest(response.test_name || "");
        setTotalMcqQuestion(response.total_mcq_count || 0);
        setTotalMriQuestion(response.total_mri_count || 0);
        setTotalFillBlanksQuestion(response.total_fill_blanks_count || 0);
        setTotalDescriptiveQuestion(response.total_descriptive_count || 0);
        setTotalCodingQuestion(response.total_coding_count || 0);
        setTime(response.total_time ? response.total_time.toString() : "");
        setSkill(sheetName);

        // Set difficulty level counts with null checks
        setEasyMcqCount(response.easy_mcq_count || 0);
        setMediumMcqCount(response.medium_mcq_count || 0);
        setHardMcqCount(response.hard_mcq_count || 0);

        setEasyMriCount(response.easy_mri_count || 0);
        setMediumMriCount(response.medium_mri_count || 0);
        setHardMriCount(response.hard_mri_count || 0);

        setEasyFillBlanksCount(response.easy_fill_blanks_count || 0);
        setMediumFillBlanksCount(response.medium_fill_blanks_count || 0);
        setHardFillBlanksCount(response.hard_fill_blanks_count || 0);

        setEasyDescriptiveCount(response.easy_descriptive_count || 0);
        setMediumDescriptiveCount(response.medium_descriptive_count || 0);
        setHardDescriptiveCount(response.hard_descriptive_count || 0);

        setEasyCodingCount(response.easy_coding_count || 0);
        setMediumCodingCount(response.medium_coding_count || 0);
        setHardCodingCount(response.hard_coding_count || 0);

        setIsAutoPopulated(true);

        toast({
          title: "CSV file uploaded successfully!",
          status: "success",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      } catch (error) {
        console.error("Error uploading CSV file:", error);
        toast({
          title: "Error uploading file",
          description: error.message || "Failed to upload CSV file",
          status: "error",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      }
    }

    if (zipFile) {
      const zipFormData = new FormData();
      zipFormData.append("zipfile", zipFile);
      zipFormData.append("company_id", companyId);

      // If you have or need to add additional data to the form
      if (imageFolderName) {
        zipFormData.append("folder_name", imageFolderName);
      }

      try {
        // Pass testId as the second parameter if needed
        const imageResponse = await saveImagequestion(zipFormData, testId);
        console.log("Image upload response:", imageResponse);

        if (
          imageResponse &&
          // Check for common success indicators in the response
          (imageResponse.status ===
            "File saved, extracted, and zipped successfully!" ||
            imageResponse.status === "success" ||
            imageResponse.message === "success")
        ) {
          toast({
            title: "Zip file uploaded successfully!",
            status: "success",
            position: "top",
            isClosable: true,
            duration: 2000,
          });
        } else {
          // If the response doesn't contain a clear success indicator but no error was thrown
          toast({
            title: "Zip file processed",
            description: "The file was processed, but check for any issues",
            status: "info",
            position: "top",
            isClosable: true,
            duration: 2000,
          });
        }
      } catch (error) {
        console.error("Error uploading ZIP file:", error);
        toast({
          title: "Error uploading image zip file",
          description: error.message || "Failed to upload zip file",
          status: "error",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      }
    }
  };

  const handleMcqCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalMcqQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 1; // 1 minute per MCQ question

    setTotalMcqQuestion(newValue); // Store raw input value
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleMriCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalMriQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 1; // 1 minute per MRI question

    setTotalMriQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleFillBlanksCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalFillBlanksQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 1; // 1 minute per Fill Blanks question

    setTotalFillBlanksQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleDescriptiveCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalDescriptiveQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 3; // 3 minutes per Descriptive question

    setTotalDescriptiveQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleCodingCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalCodingQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 5; // 5 minutes per Coding question

    setTotalCodingQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  useEffect(() => {
    if (testId) {
      fetchTestSettings();
      fetchCalculatorSettings();
    }
  }, [testId]);

  async function fetchTestSettings() {
    try {
      const testSettingsResult = await getTestCreation(testId);

      if (testSettingsResult && testSettingsResult.test_info) {
        const {
          test_name = "",
          difficulty = "",
          proficiency = "",
          total_mcq_question = 0,
          total_mri_question = 0,
          total_fill_blanks_question = 0,
          total_descriptive_question = 0,
          total_coding_question = 0,
          topics = "",
          easy_mcq_count = 0,
          medium_mcq_count = 0,
          hard_mcq_count = 0,
          easy_mri_count = 0,
          medium_mri_count = 0,
          hard_mri_count = 0,
          easy_fill_blanks_count = 0,
          medium_fill_blanks_count = 0,
          hard_fill_blanks_count = 0,
          easy_descriptive_count = 0,
          medium_descriptive_count = 0,
          hard_descriptive_count = 0,
          easy_coding_count = 0,
          medium_coding_count = 0,
          hard_coding_count = 0,
          test_subscription_type = "",
          total_time = "00:00",
          token_expiration_date = "",
          skills = "",
          image_folder_name = "",
          test_settings_created = false,
          campus = false, // Add this line to get campus value with default as false
          public_test = false, // Add this line to get public_test value with default as false
          negative_marking = false, // Add this line to get negative_marking value with default as false
          negative_mark_value = "", // Add this line to get negative_mark_value with default as empty string
        } = testSettingsResult.test_info;

        if (test_settings_created) {
          setIsSettingsSaved(true);

          const topicsArray = topics ? topics.split(",") : [];
          const timeString = total_time.split(":")[1] || "0"; // Handle time parsing safely

          // Set the fetched test settings
          setNameTest(test_name);
          setType(test_subscription_type);
          setQuestionSheetType(topics);
          setTestDifficult(difficulty);
          setTestProficiency(proficiency);
          setTotalMcqQuestion(total_mcq_question);
          setTotalMriQuestion(total_mri_question);
          setTotalFillBlanksQuestion(total_fill_blanks_question);
          setTotalDescriptiveQuestion(total_descriptive_question);
          setTotalCodingQuestion(total_coding_question);
          setEasyMcqCount(easy_mcq_count);
          setMediumMcqCount(medium_mcq_count);
          setHardMcqCount(hard_mcq_count);
          setEasyMriCount(easy_mri_count);
          setMediumMriCount(medium_mri_count);
          setHardMriCount(hard_mri_count);
          setEasyFillBlanksCount(easy_fill_blanks_count);
          setMediumFillBlanksCount(medium_fill_blanks_count);
          setHardFillBlanksCount(hard_fill_blanks_count);
          setEasyDescriptiveCount(easy_descriptive_count);
          setMediumDescriptiveCount(medium_descriptive_count);
          setHardDescriptiveCount(hard_descriptive_count);
          setEasyCodingCount(easy_coding_count);
          setMediumCodingCount(medium_coding_count);
          setHardCodingCount(hard_coding_count);
          setTime(timeString);
          setTokenExpiration(token_expiration_date);
          setSkills(skills);
          setSkill(topics);
          setImageFolderName(image_folder_name || ""); // Set image folder name from API
          setSkillOptionArray([...topicsArray]);
          setIsCampusEnabled(campus); // Set the campus state
          setIsPublicUrlEnabled(public_test === "true"); // Set the public URL state
          setIsNegativeMarkingEnabled(negative_marking === "true"); // Set the negative marking state
          setNegativeMarkValue(negative_mark_value || ""); // Set the negative mark value
        } else {
          resetTestFields(); // Reset fields if the test settings were not created
        }
      } else {
        resetTestFields(); // Reset fields if no test info is returned
      }
    } catch (error) {
      console.error("Error fetching test settings:", error);
      resetTestFields(); // Ensure fields are reset even if an error occurs
    }
  }

  async function fetchCalculatorSettings() {
    if (!testId) return;

    try {
      const response = await api.get(`/get_calculater_flag?test_id=${testId}`);
      if (response.data && response.data.calculater) {
        setIsCalculatorEnabled(response.data.calculater);
      }
    } catch (error) {
      console.error("Error fetching calculator settings:", error);
      // Default to "no" if there's an error
      setIsCalculatorEnabled("no");
    }
  }

  // Add this function to update calculator settings
  async function updateCalculatorSettings() {
    try {
      await api.post("/set_calculater_flag", {
        test_id: testId,
        calculater: isCalculatorEnabled,
      });

      // toast({
      //   title: `Calculator ${
      //     isCalculatorEnabled === "yes" ? "enabled" : "disabled"
      //   } successfully`,
      //   status: "success",
      //   position: "top",
      //   isClosable: true,
      //   duration: 2000,
      // });
    } catch (error) {
      console.error("Error updating calculator settings:", error);
      toast({
        title: "Error updating calculator settings",
        description: error.message || "Failed to update calculator settings",
        status: "error",
        position: "top",
        isClosable: true,
        duration: 2000,
      });
    }
  }

  // Function to reset all test fields
  function resetTestFields() {
    setNameTest("");
    setType("");
    setQuestionSheetType("");
    setTestDifficult("");
    setTestProficiency("");
    setTotalMcqQuestion(0);
    setTotalMriQuestion(0);
    setTotalFillBlanksQuestion(0);
    setTotalDescriptiveQuestion(0);
    setTotalCodingQuestion(0);
    setEasyMcqCount(0);
    setMediumMcqCount(0);
    setHardMcqCount(0);
    setEasyMriCount(0);
    setMediumMriCount(0);
    setHardMriCount(0);
    setEasyFillBlanksCount(0);
    setMediumFillBlanksCount(0);
    setHardFillBlanksCount(0);
    setEasyDescriptiveCount(0);
    setMediumDescriptiveCount(0);
    setHardDescriptiveCount(0);
    setEasyCodingCount(0);
    setMediumCodingCount(0);
    setHardCodingCount(0);
    setTime("");
    setSkill("");
    setIsSettingsSaved(false);
    setTokenExpiration("");
    setType("");
    setSkills("");
    setImageFolderName(""); // Reset image folder name
    setSkillOptionArray([]);
    setIsCampusEnabled(false); // Reset campus setting to false
    setIsPublicUrlEnabled(false); // Reset public URL setting to false
    setShowPublicLinkSection(false); // Reset public link section visibility
    setIsNegativeMarkingEnabled(false); // Reset negative marking setting to false
    setNegativeMarkValue(""); // Reset negative mark value
    setPublicUrl(""); // Reset public URL
    setCopied(false); // Reset copied state
  }
  const logActionApiCall = async (actionMessage) => {
    const baseUrl = url.baseUrl; // Base URL for your API
    const logActionUrl = `${baseUrl}/log_action`; // Log action endpoint

    const useriddata = JSON.parse(sessionStorage.getItem("userId"));
    const usertypedata = JSON.parse(sessionStorage.getItem("userType"));

    // Prepare the log data
    const formData = [
      { key: "id_type", value: usertypedata },
      { key: "id", value: useriddata },
      { key: "action", value: actionMessage },
    ];

    // Convert formData to x-www-form-urlencoded format
    const data = new URLSearchParams();
    formData.forEach(({ key, value }) => {
      data.append(key, value);
    });

    // Make the POST request to log the action
    try {
      await axios.post(logActionUrl, data);
    } catch (error) {
      console.error("Error logging action:", error.message);
    }
  };

  const handleTestSettings = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (nameTest === "") {
      setNameTestError(true);
    } else {
      setNameTestError(false);
    }

    if (time === "") {
      setTimeError(true);
    } else {
      setTimeError(false);
    }

    if (tokenExpiration === "" || !tokenExpiration) {
      setTokenExpirationError(true);
    } else {
      setTokenExpirationError(false);
    }

    // Return if any required field is empty
    if (nameTest === "" || time === "" || !tokenExpiration) {
      return;
    }

    // Base test settings that are always required
    const testSettings = {
      test_name: nameTest,
      test_id: testId,
      difficulty: testDifficulty,
      proficiency: testProficiency,
      total_mcq_question: totalMcqQuestion,
      total_mri_question: totalMriQuestion,
      total_fill_blanks_question: totalFillBlanksQuestion,
      total_descriptive_question: totalDescriptiveQuestion,
      total_coding_question: totalCodingQuestion,
      total_time: time,
      topics: skill,
      recruiter_id: userId,
      company_id: companyId,
      test_subscription_type: testType,
      token_expiration_date: tokenExpiration,
      test_settings_created: true,
      skills: skills,
      image_folder_name: imageFolderName,
      campus: isCampusEnabled,
      public_test: isPublicUrlEnabled,
      negative_marking: isNegativeMarkingEnabled,
      negative_mark_value: negativeMarkValue,
      Certificate_assesment: assessmentType === "certificate",
    };

    // Add difficulty-specific counts based on mode
    if (testDifficulty === "manual") {
      Object.assign(testSettings, {
        easy_mcq_count: easyMcqCount,
        medium_mcq_count: mediumMcqCount,
        hard_mcq_count: hardMcqCount,
        easy_mri_count: easyMriCount,
        medium_mri_count: mediumMriCount,
        hard_mri_count: hardMriCount,
        easy_fill_blanks_count: easyFillBlanksCount,
        medium_fill_blanks_count: mediumFillBlanksCount,
        hard_fill_blanks_count: hardFillBlanksCount,
        easy_descriptive_count: easyDescriptiveCount,
        medium_descriptive_count: mediumDescriptiveCount,
        hard_descriptive_count: hardDescriptiveCount,
        easy_coding_count: easyCodingCount,
        medium_coding_count: mediumCodingCount,
        hard_coding_count: hardCodingCount,
      });
    } else {
      Object.assign(testSettings, {
        easy_mcq_count: 0,
        medium_mcq_count: 0,
        hard_mcq_count: 0,
        easy_mri_count: 0,
        medium_mri_count: 0,
        hard_mri_count: 0,
        easy_fill_blanks_count: 0,
        medium_fill_blanks_count: 0,
        hard_fill_blanks_count: 0,
        easy_descriptive_count: 0,
        medium_descriptive_count: 0,
        hard_descriptive_count: 0,
        easy_coding_count: 0,
        medium_coding_count: 0,
        hard_coding_count: 0,
      });
    }

    try {
      // First save the test settings
      const response = await createOrUpdateTest(testSettings);
      console.log("Test creation complete response:", response);

      // Store the full response for debugging
      fetchResponse(response);
      setIsSettingsSaved(true);

      // Extract test ID correctly from the response
      let createdTestId;

      // Based on the actual response structure, the test_id is in response.test_info.test_id
      if (response && response.test_info && response.test_info.test_id) {
        createdTestId = response.test_info.test_id;
        console.log(
          "Extracted test_id from response.test_info:",
          createdTestId
        );
      }
      // Try other possible locations if the above fails
      else if (response && response.test_id) {
        createdTestId = response.test_id;
        console.log("Extracted test_id directly from response:", createdTestId);
      } else if (response && response.data && response.data.test_id) {
        createdTestId = response.data.test_id;
        console.log("Extracted test_id from response.data:", createdTestId);
      }

      // If we couldn't extract the ID, use the existing testId as fallback
      if (!createdTestId) {
        createdTestId = testId;
        console.log("Using existing testId as fallback:", createdTestId);
      }

      // Only proceed with calculator settings if we have a valid test ID
      if (createdTestId) {
        try {
          console.log(
            "Sending calculator settings with test_id:",
            createdTestId
          );

          const calculatorResponse = await api.post("/set_calculater_flag", {
            test_id: createdTestId,
            calculater: isCalculatorEnabled,
          });

          console.log("Calculator API response:", calculatorResponse);
          console.log(
            `Calculator ${
              isCalculatorEnabled === "yes" ? "enabled" : "disabled"
            } for test ID ${createdTestId}`
          );

          toast({
            title: `Calculator ${
              isCalculatorEnabled === "yes" ? "enabled" : "disabled"
            } successfully`,
            status: "success",
            position: "top",
            isClosable: true,
            duration: 2000,
          });
        } catch (calculatorError) {
          console.error("Error updating calculator settings:", calculatorError);
          toast({
            title: "Warning",
            description:
              "Test settings saved but calculator settings failed to update.",
            status: "warning",
            position: "top",
            isClosable: true,
            duration: 3000,
          });
        }
      } else {
        console.error("No valid test ID found for calculator settings");
        toast({
          title: "Warning",
          description:
            "Test settings saved but could not obtain test ID for calculator settings.",
          status: "warning",
          position: "top",
          isClosable: true,
          duration: 3000,
        });
      }

      const successMessage =
        testType === "training"
          ? "Training Assessment Created Successfully"
          : "Test Assessment Created Successfully";

      toast({
        title: successMessage,
        status: "success",
        position: "top",
        isClosable: true,
        duration: 3000,
      });

      await logActionApiCall(successMessage);

      // Comment this line temporarily to see console logs
      Router.reload();
    } catch (error) {
      console.log("Error Response", error);
      const errorMessage =
        error.response?.data?.error || "An unexpected error occurred";

      if (error.response?.status === 400) {
        if (
          errorMessage ===
            "Total time exceeds the allowed assessment duration limit." ||
          errorMessage ===
            "Total number of questions exceeds the allowed limit."
        ) {
          toast({
            title: "Error",
            description: errorMessage,
            status: "error",
            position: "top",
            isClosable: true,
            duration: 3000,
          });
        } else if (
          errorMessage ===
            "Assessment limit exceeded. Cannot create a new test." ||
          errorMessage === "Training limit exceeded. Cannot create a new test."
        ) {
          toast({
            title: "Error",
            description: (
              <div>
                {errorMessage}
                <Button
                  size="sm"
                  colorScheme="blue"
                  onClick={async () => {
                    toast.closeAll();
                    try {
                      if (customerId === 0) {
                        // If no customer ID, create new customer
                        const response = await api.post("/add_customer", {
                          customer_name: "",
                          mob_no: "",
                          email_id: "",
                        });

                        if (response.data && response.data.customer_id) {
                          router.push(
                            `/pricing?customer_id=${response.data.customer_id}&pricing=2`
                          );
                        } else {
                          throw new Error("No customer ID received");
                        }
                      } else {
                        // If customer ID exists, use it directly
                        router.push(
                          `/pricing?customer_id=${customerId}&pricing=2`
                        );
                      }
                    } catch (error) {
                      console.error("Error details:", error);
                      toast({
                        title: "Unable to process request",
                        description: "Please try again later",
                        status: "error",
                        position: "top",
                        isClosable: true,
                        duration: 3000,
                      });
                    }
                  }}
                >
                  Renew Now
                </Button>
              </div>
            ),
            status: "error",
            position: "top",
            isClosable: true,
            duration: 5000,
          });
        } else if (
          errorMessage ===
          "The company's validity period has expired. Cannot create a new test or training."
        ) {
          toast({
            title: "Error",
            description: errorMessage,
            status: "error",
            position: "top",
            isClosable: true,
            duration: 5000,
          });
        } else {
          toast({
            title: "An error occurred",
            description: "Please ensure all fields are populated correctly.",
            status: "error",
            position: "top",
            isClosable: true,
            duration: 3000,
          });
        }

        const errorAction =
          testType === "training"
            ? "Error in Training Creation"
            : "Error in Test Creation";
        await logActionApiCall(errorAction);
      } else {
        toast({
          title: "An unexpected error occurred",
          description: error.message,
          status: "error",
          position: "top",
          isClosable: true,
          duration: 3000,
        });
      }
    }
  };


  return (
    <>
      <Modal
        closeIcon
        open={isTestSettingsModalOpen}
        onClose={(e) => setIsTestSettingModalOpen(false)}
        size="fullscreen"
      >
        <div style={{ padding: "10px", display: "flex", alignItems: "center" }}>
          <h3 style={{ margin: 0 }}>Assessment</h3>
          <HelpIconWithTooltip />
        </div>
        <div>
          <CsvUploader />
        </div>
        
        {/* Public Link Section - only show if public URL is enabled AND view icon is clicked */}
        {isPublicUrlEnabled && showPublicLinkSection && (
          <div style={{ padding: "20px", backgroundColor: "#f8f9fa", margin: "10px", borderRadius: "8px" }}>
            <Alert status="info" mb={4}>
              <AlertIcon />
              <Box>
                <AlertTitle>Public Assessment Link</AlertTitle>
                <AlertDescription>
                  This assessment is publicly accessible. Share the link below with candidates.
                </AlertDescription>
              </Box>
            </Alert>
            
            <VStack spacing={4} align="stretch">
              <Box>
                <Text fontWeight="medium" mb={2}>
                  Public Link:
                </Text>
                <InputGroup>
                  <ChakraInput
                    value={publicUrl}
                    isReadOnly
                    bg="gray.50"
                    fontSize="sm"
                  />
                  <InputRightElement>
                    <HStack spacing={1}>
                      <Tooltip label="Copy link">
                        <IconButton
                          icon={<Icon name="copy" />}
                          onClick={handleCopyLink}
                          colorScheme={copied ? "green" : "blue"}
                          variant={copied ? "solid" : "outline"}
                          size="sm"
                          aria-label="Copy link"
                        />
                      </Tooltip>
                      <Tooltip label="Open link">
                        <IconButton
                          icon={<Icon name="external" />}
                          onClick={handleOpenLink}
                          colorScheme="blue"
                          variant="outline"
                          size="sm"
                          aria-label="Open link"
                        />
                      </Tooltip>
                    </HStack>
                  </InputRightElement>
                </InputGroup>
              </Box>
              
              <Box>
                <Text fontWeight="medium" mb={2}>
                  How to use this link:
                </Text>
                <VStack spacing={2} align="start">
                  <Text fontSize="sm" color="gray.600">
                    1. Copy the link above
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    2. Share it with candidates via email, message, or any platform
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    3. Candidates can access the assessment without login
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    4. You can track their progress from your dashboard
                  </Text>
                </VStack>
              </Box>
              
              <Box>
                <ChakraButton
                  colorScheme="green"
                  onClick={() => setIsPublicLinkModalOpen(true)}
                  leftIcon={<EmailIcon />}
                  size="md"
                >
                  Send Invite Emails
                </ChakraButton>
              </Box>
            </VStack>
          </div>
        )}
        
        {/* Public Link Modal for sending invites */}
        <PublicLinkModal
          isOpen={isPublicLinkModalOpen}
          onClose={() => setIsPublicLinkModalOpen(false)}
          assessmentId={testId}
          assessmentName={nameTest}
          companyId={companyId}
          recruiterId={userId}
        />
        
        <hr></hr>

        <Modal.Content scrolling>
          <Modal.Description>
            <Form>
              <Form.Group widths="equal" inline>
                <label>Select Existing Assessment</label>
                <Form.Field width={8}>
                  <Dropdown
                    placeholder="Click to see existing assessments"
                    fluid
                    selection
                    loading={isLoadingFiles}
                    options={csvFilesList || []} // Add fallback empty array
                    value={selectedCsvFile}
                    onChange={(e, { value }) => {
                      console.log("Selected value:", value); // Debug log
                      handleCsvFileSelection(value);
                    }}
                    noResultsMessage="No assessments found"
                  />
                </Form.Field>
              </Form.Group>

              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  basic
                  color="blue"
                  size="small"
                  onClick={handleTemplateDownload}
                >
                  Download Template
                </Button>
              </div>

              <Form.Group widths="equal" inline>
                <label>CSV Assessment</label>
                <Form.Field width={4} required>
                  <Input
                    type="file"
                    accept=".csv"
                    onChange={handleCsvFileUpload}
                  />
                  {nameTestError && (
                    <span style={{ color: "red", marginLeft: "20px" }}>
                      Select CSV File
                    </span>
                  )}
                </Form.Field>

                <label>Image Assessment</label>
                <Form.Field width={4} required>
                  <Input
                    type="file"
                    accept=".zip"
                    onChange={handleZipFileUpload}
                  />
                  {nameTestError && (
                    <span style={{ color: "red", marginLeft: "20px" }}>
                      Select Image File
                    </span>
                  )}
                </Form.Field>

                <Form.Field width={4}>
                  <Button
                    color="blue"
                    onClick={handleQestionUpload}
                    disabled={isSettingsSaved}
                  >
                    Upload
                  </Button>
                </Form.Field>
              </Form.Group>

              <Form.Group inline>
                <label>Filename</label>
                <p>{questionSheetType}</p>
                {nameTestError && (
                  <span style={{ color: "red", marginLeft: "20px" }}>
                    Selected File
                  </span>
                )}
              </Form.Group>

              {imageFolderName && (
                <Form.Group inline>
                  <label>Image Folder</label>
                  <p>{imageFolderName}</p>
                </Form.Group>
              )}

              <Form.Group inline>
                <Form.Field
                  required
                  control={Input}
                  label="Assessment Name"
                  placeholder="Name of the Assessment"
                  onChange={(e) => setNameTest(e.target.value)}
                  type="text"
                  value={nameTest}
                  error={nameTestError}
                />
                {nameTestError && (
                  <span style={{ color: "red" }}>
                    Please Enter the Assessment Name
                  </span>
                )}

                <Form.Field
                  control={Input}
                  label="Total Time"
                  placeholder="in mins"
                  type="number"
                  min={0}
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  required
                  error={timeError}
                />

                {timeError && (
                  <span style={{ color: "red" }}>
                    Please Enter the Total Time
                  </span>
                )}

                <label>
                  Token Expiration Date <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="date"
                  value={tokenExpiration}
                  required
                  style={{ maxWidth: "15em" }}
                  onChange={(e) => setTokenExpiration(e.target.value)}
                />
                {tokenExpirationError && (
                  <span style={{ color: "red", marginLeft: "20px" }}>
                    Please Enter Token Expiration Date
                  </span>
                )}
              </Form.Group>

              <Form.Group inline>
                <label>Assessment Type</label>

                {/* Show both options for Certificate Assessment */}
                {assessmentType === "certificate" && (
                  <>
                    <Form.Field
                      required
                      control={Radio}
                      label="Training"
                      value="training"
                      checked={testType === "training"}
                      onChange={(e, { value }) => setType(value)}
                    />
                    <Form.Field
                      required
                      control={Radio}
                      label="Test"
                      value="test"
                      checked={testType === "test"}
                      onChange={(e, { value }) => setType(value)}
                    />
                  </>
                )}

                {/* Show only Test option for Interview Assessment - Training is disabled */}
                {assessmentType === "interview" && (
                  <>
                    <Form.Field
                      required
                      control={Radio}
                      label="Training"
                      value="training"
                      checked={false} // Force unchecked
                      disabled={true} // Disable the option
                      onChange={(e, { value }) => {}} // No-op function
                    />
                    <Form.Field
                      required
                      control={Radio}
                      label="Test"
                      value="test"
                      checked={true} // Force checked
                      onChange={(e, { value }) => setType(value)}
                    />
                  </>
                )}

                {/* Fallback: Show both options if assessmentType is not set */}
                {(!assessmentType ||
                  (assessmentType !== "interview" &&
                    assessmentType !== "certificate")) && (
                  <>
                    <Form.Field
                      required
                      control={Radio}
                      label="Training"
                      value="training"
                      checked={testType === "training"}
                      onChange={(e, { value }) => setType(value)}
                    />
                    <Form.Field
                      required
                      control={Radio}
                      label="Test"
                      value="test"
                      checked={testType === "test"}
                      onChange={(e, { value }) => setType(value)}
                    />
                  </>
                )}

                {nameTestError && (
                  <span style={{ color: "red", marginLeft: "20px" }}>
                    Please Select Any Test Type
                  </span>
                )}

                {testType === "training" && assessmentType !== "interview" && (
                  <>
                    <label style={{ marginLeft: "65px" }}>
                      Skills <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={skills}
                      required
                      style={{ maxWidth: "25em" }}
                      onChange={(e) => setSkills(e.target.value)}
                    />
                    {nameTestError && (
                      <span style={{ color: "red", marginLeft: "20px" }}>
                        Please Enter the Skills
                      </span>
                    )}
                  </>
                )}
              </Form.Group>
              <Form.Group>
                <Form.Field
                  required
                  control={Input}
                  label="Total multiple choice questions"
                  type="number"
                  min={0}
                  value={totalMcqQuestion}
                  // onChange={(e) => setTotalMcqQuestion(e.target.value)}
                  onChange={handleMcqCountChange}
                />

                <Form.Field
                  required
                  control={Input}
                  label="Total Multiple Response Questions"
                  type="number"
                  min={0}
                  value={totalMriQuestion}
                  // onChange={(e) => setTotalMriQuestion(e.target.value)}
                  onChange={handleMriCountChange}
                />

                <Form.Field
                  required
                  control={Input}
                  label="Total Fill Blanks"
                  type="number"
                  min={0}
                  value={totalFillBlanksQuestion}
                  // onChange={(e) => setTotalFillBlanksQuestion(e.target.value)}
                  onChange={handleFillBlanksCountChange}
                />

                <Form.Field
                  required
                  control={Input}
                  label="Total Descriptive"
                  placeholder="Total Descriptive"
                  type="number"
                  min={0}
                  value={totalDescriptiveQuestion}
                  // onChange={(e) => setTotalDescriptiveQuestion(e.target.value)}
                  onChange={handleDescriptiveCountChange}
                />
                <Form.Field
                  required
                  control={Input}
                  label="Total Coding"
                  placeholder="Total Coding"
                  type="number"
                  min={0}
                  value={totalCodingQuestion}
                  // onChange={(e) => setTotalCodingQuestion(e.target.value)}
                  onChange={handleCodingCountChange}
                />
              </Form.Group>
              <Form.Group inline>
                <label>Mode </label>
                <Form.Field
                  required
                  control={Radio}
                  label="Default"
                  checked={testDifficulty === "default"}
                  onChange={(e) => setTestDifficult("default")}
                />
                <Form.Field
                  required
                  control={Radio}
                  label="Manual"
                  checked={testDifficulty === "manual"}
                  onChange={(e) => setTestDifficult("manual")}
                />
                {nameTestError && (
                  <span style={{ color: "red", marginLeft: "20px" }}>
                    Select Difficulty Level
                  </span>
                )}
              </Form.Group>

              {testDifficulty === "manual" ? (
                <Form>
                  <Form.Group widths="equal">
                    <Form.Field
                      required
                      control={Input}
                      label="Easy multiple choice questions count"
                      type="number"
                      min={0}
                      value={easyMcqCount}
                      onChange={(e) => setEasyMcqCount(e.target.value)}
                    />
                    <Form.Field
                      required
                      control={Input}
                      label="Medium multiple choice questions"
                      type="number"
                      min={0}
                      value={mediumMcqCount}
                      onChange={(e) => setMediumMcqCount(e.target.value)}
                    />

                    <Form.Field
                      required
                      control={Input}
                      label="Hard multiple choice questions=
                    "
                      type="number"
                      min={0}
                      value={hardMcqCount}
                      onChange={(e) => setHardMcqCount(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group widths="equal">
                    <Form.Field
                      required
                      control={Input}
                      label="Easy Multiple Response"
                      type="number"
                      min={0}
                      value={easyMriCount}
                      onChange={(e) => setEasyMriCount(e.target.value)}
                    />
                    <Form.Field
                      required
                      control={Input}
                      label="Medium Multiple Response"
                      type="number"
                      min={0}
                      value={mediumMriCount}
                      onChange={(e) => setMediumMriCount(e.target.value)}
                    />

                    <Form.Field
                      required
                      control={Input}
                      label="Hard Multiple Response"
                      type="number"
                      min={0}
                      value={hardMriCount}
                      onChange={(e) => setHardMriCount(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group widths="equal">
                    <Form.Field
                      required
                      control={Input}
                      label="Easy Fill Blanks"
                      type="number"
                      min={0}
                      value={easyFillBlanksCount}
                      onChange={(e) => setEasyFillBlanksCount(e.target.value)}
                    />
                    <Form.Field
                      required
                      control={Input}
                      label="Medium Fill Blanks"
                      type="number"
                      min={0}
                      value={mediumFillBlanksCount}
                      onChange={(e) => setMediumFillBlanksCount(e.target.value)}
                    />

                    <Form.Field
                      required
                      control={Input}
                      label="Hard Fill Blanks"
                      type="number"
                      min={0}
                      value={hardFillBlanksCount}
                      onChange={(e) => setHardFillBlanksCount(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group widths="equal">
                    <Form.Field
                      required
                      control={Input}
                      label="Easy Descriptive"
                      type="number"
                      min={0}
                      value={easyDescriptiveCount}
                      onChange={(e) => setEasyDescriptiveCount(e.target.value)}
                    />
                    <Form.Field
                      required
                      control={Input}
                      label="Medium Descriptive"
                      type="number"
                      min={0}
                      value={mediumDescriptiveCount}
                      onChange={(e) =>
                        setMediumDescriptiveCount(e.target.value)
                      }
                    />

                    <Form.Field
                      required
                      control={Input}
                      label="Hard Descriptive"
                      type="number"
                      min={0}
                      value={hardDescriptiveCount}
                      onChange={(e) => setHardDescriptiveCount(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group widths="equal">
                    <Form.Field
                      required
                      control={Input}
                      label="Easy Coding"
                      type="number"
                      min={0}
                      value={easyCodingCount}
                      onChange={(e) => setEasyCodingCount(e.target.value)}
                    />
                    <Form.Field
                      required
                      control={Input}
                      label="Medium Coding"
                      type="number"
                      min={0}
                      value={mediumCodingCount}
                      onChange={(e) => setMediumCodingCount(e.target.value)}
                    />

                    <Form.Field
                      required
                      control={Input}
                      label="Hard Coding"
                      type="number"
                      min={0}
                      value={hardCodingCount}
                      onChange={(e) => setHardCodingCount(e.target.value)}
                    />
                  </Form.Group>
                </Form>
              ) : null}

              <Form.Group inline>
                <label>Difficulty Level </label>
                <Form.Field
                  required
                  control={Radio}
                  label="Beginner"
                  checked={testProficiency === "beginner"}
                  onChange={(e) => setTestProficiency("beginner")}
                />

                <Form.Field
                  required
                  control={Radio}
                  label="Proficient"
                  checked={testProficiency === "proficient"}
                  onChange={(e) => setTestProficiency("proficient")}
                />

                <Form.Field
                  required
                  control={Radio}
                  label="Expert"
                  checked={testProficiency === "expert"}
                  onChange={(e) => setTestProficiency("expert")}
                />

                {nameTestError && (
                  <span style={{ color: "red", marginLeft: "20px" }}>
                    Select Proficiency Level
                  </span>
                )}
              </Form.Group>

              <Form.Group inline>
                <label>Enable Calculator</label>
                <Form.Field>
                  <Checkbox
                    checked={isCalculatorEnabled === "yes"}
                    onChange={(e, data) => {
                      setIsCalculatorEnabled(data.checked ? "yes" : "no");
                    }}
                  />
                </Form.Field>
              </Form.Group>

              {/* Add this new Form.Group for campus setting */}
              <Form.Group inline>
                <label>Enable Campus</label>
                <Form.Field>
                  <Checkbox
                    checked={isCampusEnabled}
                    onChange={(e, data) => {
                      setIsCampusEnabled(data.checked);
                    }}
                  />
                </Form.Field>
              </Form.Group>

              {/* Add Public URL checkbox - only for interview assessments */}
              {assessmentType !== "certificate" && (
                <Form.Group inline>
                  <label>Enable Public URL</label>
                  <Form.Field>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Checkbox
                        checked={isPublicUrlEnabled}
                        onChange={(e, data) => {
                          setIsPublicUrlEnabled(data.checked);
                          // Reset view state when toggling
                          if (!data.checked) {
                            setShowPublicLinkSection(false);
                          }
                        }}
                      />
                      {isPublicUrlEnabled && (
                        <IconButton
                          icon={<ViewIcon />}
                          onClick={() => setShowPublicLinkSection(!showPublicLinkSection)}
                          colorScheme="blue"
                          variant="outline"
                          size="sm"
                          aria-label="View public link"
                          title="View Public Link"
                        />
                      )}
                    </div>
                  </Form.Field>
                </Form.Group>
              )}

              {/* Add Negative Marking checkbox */}
              <Form.Group inline>
                <label>Enable Negative Marking</label>
                <Form.Field>
                  <Checkbox
                    checked={isNegativeMarkingEnabled}
                    onChange={(e, data) => {
                      setIsNegativeMarkingEnabled(data.checked);
                    }}
                  />
                </Form.Field>
                {isNegativeMarkingEnabled && (
                  <Form.Field inline>
                    <label style={{ marginLeft: "10px" }}>
                      by
                    </label>
                    <Input
                      type="number"
                      placeholder="0"
                      value={negativeMarkValue}
                      onChange={(e) => setNegativeMarkValue(e.target.value)}
                      style={{ width: "80px", marginLeft: "5px" }}
                    />
                    <label style={{ marginLeft: "5px" }}>Marks</label>
                  </Form.Field>
                )}
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>

        <Button
          style={{ position: "absolute", right: "1em", bottom: "1em" }}
          type="submit"
          content="Submit"
          labelPosition="right"
          icon="checkmark"
          onClick={handleTestSettings}
          positive
          disabled={isSettingsSaved}
        >
          Submit
        </Button>
      </Modal>
    </>
  );
}

export default TestSettingsModal;